// returns "o zi" for 1, or "x zile" for x
export const displayDuration = (durationInDays: number) =>
    `${durationInDays === 1 ? 'o' : durationInDays} ${durationInDays === 1 ? 'zi' : 'zile'}`

// returns date like 15 martie 2026 (in romanian)
const parseDate = (date: Date) => date.toLocaleDateString("ro-RO", {
    day: "numeric",
    month: "long",
    year: "numeric",
})

// returns a date (parsed) if tris is one day long
// or a period if trip is multiple days
export const displayDate = (startDate: Date, durationInDays: number) => {
    if (durationInDays === 1) {
        return parseDate(startDate)
    }

    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + durationInDays - 1);

    return `${parseDate(startDate)} - ${parseDate(endDate)}`;
}